import { ChangeDetectionStrategy, Component, ChangeDetectorRef, InjectionToken, Inject, OnInit } from '@angular/core';
import { MdlDialogReference } from '@angular-mdl/core';
import { OverrideVisit } from './override-visit-info';
import { GridHeader, GridDetails } from '../../../../sample-tracking/tracking-overview/interfaces/grid';
import { FormControl } from '@angular/forms';
import { Subscription, merge, of } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { VisitInfo } from '../../register-sample-info';
import { RegisterSampleStorage } from '../../register-sample-storage';
export const OVERRIDE_VISIT_TOKEN = new InjectionToken('OverrideVisitItem');

@Component({
    selector: 'override-visit',
    template: require('./override-visit.component.html'),
    styles: [require('./override-visit.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OverrideVisitComponent implements OnInit {

    public overrideVisitInfo: OverrideVisit;
    public visitList: VisitInfo[] = [];
    public gridDetails: GridDetails;
    public searchTerm = new FormControl('');
    public searchSubscription: Subscription;
    public selectedVisit: VisitInfo;
    public gridLoadingComplete = false;
    public itemsPerPage = [10, 15, 25, 30, 45, 50];
    constructor(
        private dialog: MdlDialogReference,
        private changeDetectorRef: ChangeDetectorRef,
        private storage: RegisterSampleStorage,
        @Inject(OVERRIDE_VISIT_TOKEN) private readonly overrideVisit: OverrideVisit) {

        this.overrideVisitInfo = overrideVisit;

    }

    public onCancel() {
        this.dialog.hide(null);
    }

    public onSelect() {
        this.dialog.hide(this.selectedVisit);
    }

    public ngOnInit() {
        this.storage.getVisitDetails(this.overrideVisit.accessionData, true).subscribe((result: VisitInfo[]) => {
            this.visitList = result;
            this.gridDetails = { header: this.visitGridHeader(), data: result };
            this.gridLoadingComplete = true;
            this.changeDetectorRef.markForCheck();
        });
        const searchTermFlow = merge(
            of(''),
            this.searchTerm.valueChanges
                .pipe(
                    debounceTime(300),
                    distinctUntilChanged()
                )
        );
        this.searchSubscription = searchTermFlow.subscribe((term) => {
            this.searchVisit(term);
            this.changeDetectorRef.markForCheck();
        });
    }

    public searchVisit(term: string) {
        if (!this.visitList || !this.visitList.length) {
            return;
        }
        if (!term || !term.length) {
            this.gridDetails = { header: this.visitGridHeader(), data: this.visitList };
            this.changeDetectorRef.markForCheck();
            return;
        }
        term = term.trim().toLowerCase();
        let filterData: VisitInfo[] = [];
        for (var rowData of this.visitList) {
            for (var col of this.gridDetails.header) {
                if (col.selectRow) { continue; }
                if (`${rowData[col.key as keyof VisitInfo]}`.toLowerCase().indexOf(term) !== -1) {
                    filterData.push(rowData);
                    break;
                }
            }
        }
        this.gridDetails = { header: this.visitGridHeader(), data: filterData };
        this.changeDetectorRef.markForCheck();
    }

    public onVisitSelect($event: VisitInfo[]) {
        let selectedSamples: VisitInfo[] = $event.filter(t => t.rowSelected);
        this.selectedVisit = selectedSamples && selectedSamples.length ? selectedSamples[0] : null;
    }

    private visitGridHeader(): GridHeader[] {
        return [
            {
                displayText: '',
                key: '',
                defaultValue: ' ',
                selectId: 'visitScheduleId',
                selectRow: true
            },
            {
                key: 'protocolVisitDescription',
                displayText: 'Visit Description',
                sort: null,
                enableSearch: true,
                enableFilter: true,
            },
            {
                key: 'protocolVisitCode',
                displayText: 'PVC',
                sort: 'asc',
                enableSearch: true,
                enableFilter: true,
            }
        ];

    }
}